var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.texts.length
    ? _c(
        "div",
        { staticClass: "notice" },
        [
          _c(
            "div",
            { staticClass: "notice-cnt" },
            [
              _c("svg-icon", {
                attrs: {
                  "icon-class": "noticeBar",
                  "class-name": "icon-noticeBar",
                  size: "24",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "vertical-text-carousel",
                  style: { height: _vm.carouselHeight + "px" },
                },
                [
                  _vm.texts.length
                    ? _c(
                        "div",
                        {
                          staticClass: "text-wrapper",
                          style: {
                            transform: "translateY(" + _vm.offset + "px)",
                          },
                        },
                        _vm._l(_vm.texts, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "text-item" },
                            [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "bottom",
                                    width: "319",
                                    trigger: "hover",
                                    content: item.desc,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-cnt",
                                      style: item.style || {},
                                      attrs: { slot: "reference" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handle(item)
                                        },
                                      },
                                      slot: "reference",
                                    },
                                    [_vm._v(" " + _vm._s(item.text) + " ")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _c("DownloadModal", { ref: "DownloadModal" }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }